import type { VideoHistoryEntry } from '../shared'

export function videoHistoryDuration(entry: VideoHistoryEntry | undefined): number | undefined {
  const metadata = entry?.result?.metadata
  const value = metadata?.duration_seconds ?? (metadata && 'duration' in metadata ? metadata.duration : undefined)
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : undefined
}
